import type { ReactNode } from 'react'

export interface SlotSymbol {
  id: string
  label: string
  color: string
  lobeIcon: string
}

export const SLOT_SYMBOLS: SlotSymbol[] = [
  { id: 'gpt', label: 'GPT', color: '#10a37f', lobeIcon: 'OpenAI.Color' },
  { id: 'claude', label: 'Claude', color: '#d97757', lobeIcon: 'Claude.Color' },
  { id: 'gemini', label: 'Gemini', color: '#1a73e8', lobeIcon: 'Gemini.Color' },
  { id: 'deepseek', label: 'DeepSeek', color: '#4f46e5', lobeIcon: 'DeepSeek.Color' },
  { id: 'qwen', label: 'Qwen', color: '#0ea5e9', lobeIcon: 'Qwen.Color' },
  { id: 'spark', label: 'Spark', color: '#f59e0b', lobeIcon: 'Spark.Color' },
  { id: 'glm', label: 'GLM', color: '#8b5cf6', lobeIcon: 'ChatGLM.Color' },
  { id: 'yi', label: 'Yi', color: '#06b6d4', lobeIcon: '' },
  { id: 'doubao', label: 'Doubao', color: '#ec4899', lobeIcon: 'Doubao.Color' },
  { id: 'bomb', label: 'Bomb', color: '#ef4444', lobeIcon: '' },
]

export const SYMBOL_MAP: Record<string, SlotSymbol> = Object.fromEntries(
  SLOT_SYMBOLS.map((s) => [s.id, s])
)

export interface SlotMachineConfig {
  enabled: boolean
  max_spins_per_day: number
  cost_per_spin: number
  min_match2_reward: number
  max_match2_reward: number
  min_match3_reward: number
  max_match3_reward: number
  min_bomb_penalty: number
  max_bomb_penalty: number
}

export interface SpinResult {
  symbols: string[]
  result: 'win' | 'loss' | 'bomb'
  reward_quota: number
  cost_quota: number
}

export interface SlotMachineStats {
  enabled: boolean
  max_spins_per_day: number
  cost_per_spin: number
  spins_today: number
  spins_remaining: number
  total_spins: number
  total_wins: number
  total_bombs: number
  total_reward: number
  total_cost: number
}

export interface SlotMachineRecord {
  id: number
  user_id: number
  symbols: string
  result: string
  reward_quota: number
  cost_quota: number
  created_at: number
}

export interface SlotMachineHistory {
  records: SlotMachineRecord[]
  total: number
  page: number
  page_size: number
}